import { DashboardBalanceCard } from "../component/DashboardBalanceCard";
import { DashboardDateCard } from "../component/DashboardDateCard";
import { PageHeader } from "../component/PageHeader";
import { RecentAllowanceCard } from "../component/RecentAllowanceCard";
import { RecentStakingCard } from "../component/RecentStakingCard";

export const Dashboard = () => {
  return (
    <>
      <PageHeader title="Dashboard" />
      <div className="grid grid-cols-12 gap-x-5">
        <DashboardDateCard />
      </div>
      <div className="grid grid-cols-12 gap-x-5">
        <DashboardBalanceCard apy={50} />
        <DashboardBalanceCard apy={30} />
        <DashboardBalanceCard apy={20} />
      </div>

      <div className="grid grid-cols-12 gap-x-5">
        <RecentStakingCard apy={50} />
        <RecentStakingCard apy={30} />
        <RecentStakingCard apy={20} />
      </div>
      <div className="grid grid-cols-12 gap-x-5">
        <RecentAllowanceCard apy={50} />
        <RecentAllowanceCard apy={30} />
        <RecentAllowanceCard apy={20} />
      </div>
    </>
  );
};
